var accomodationTop = {
	options: {
		price_per_day: 0,
	},

	selectors: {
		input_top_days: ".js-accomodation-input-top-days",
		info_days: ".js-accomodation-info-days",
		info_price_per_day: ".js-accomodation-info-top-price-per-day",
		info_subtotal: ".js-accomodation-info-subtotal",
		info_total: ".js-accomodation-info-total",
	},

	init: function () {
		const self = this;

		self.load();
	},

	load: function () {
		const self = this;

		if (jQuery(self.selectors.input_top_days).length === 0) {
			return; //exit not found
		}

		self.options.price_per_day = parseFloat(jQuery(self.selectors.info_price_per_day).data("default-price"));

		jQuery(self.selectors.input_top_days).on("input", function () {
			self.reCalc();
		});

		//init
		self.reCalc();
	},

	reCalc: function () {
		const self = this;

		const days = parseInt(jQuery(self.selectors.input_top_days).val());
		const total = (self.options.price_per_day * days).toLocaleString() + " " + sikmoVars.currency;

		jQuery(self.selectors.info_days).html(days);
		jQuery(self.selectors.info_subtotal).html(total);
		jQuery(self.selectors.info_total).html(total);
	},
}

// Export
export { accomodationTop };